import React, { useState, useEffect } from "react";
import "./Login.css";
import AdminDashboard from "../Admin";
import { useConfig } from "../../context/ConfigContext";

function Login() {
  const { config } = useConfig();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [otp, setOtp] = useState("");
  const [stage, setStage] = useState("password"); // "password" | "otp"
  const [maskedEmail, setMaskedEmail] = useState("");

  const [error, setError] = useState("");
  const [info, setInfo] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState()

  const apiurl = config.REACT_APP_LOGINURL ?? "http://localhost:4000/api/login";     // should point to POST /login
  const checkURL = config.REACT_APP_CHECKURL ?? "http://localhost:4000/api/login/check";   // should point to GET /check
  const otpURL = config.REACT_APP_OTP_URL ?? "http://localhost:4000/api/login/verify-otp";      // should point to POST /login/verify-otp

  useEffect(() => {
    fetch(checkURL, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!data) return;
        if (data.user) {
          setIsLoggedIn(true);
          setUser(data.user)
        }
      })
      .catch(() => {});
  }, [checkURL]);

  const handleSubmitPassword = async (e) => {
    e.preventDefault();
    setError("");
    setInfo("");

    const res = await fetch(apiurl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ username, password }),
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      setError(data.message || "Invalid username or password");
      return;
    }

    // 2FA required
    if (data.requires2FA) {
      setStage("otp");
      setMaskedEmail(data.maskedEmail || "");
      setInfo(data.message || "A login code was sent to your email.");
      return;
    }

    // logged in
    if (!data.user) {
      setError("Login succeeded, but user information was not returned.");
      return;
    }
    
    setUser(data.user);
    setIsLoggedIn(true);
    setStage("password");
    setOtp("");
  };

  const handleSubmitOtp = async (e) => {
    e.preventDefault();
    setError("");
    setInfo("");

    const res = await fetch(otpURL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ code: otp }),
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      setError(data.message || "Invalid code");
      return;
    }
    
    if (!data.user) {
      setError("Verification succeeded, but user information was not returned.");
      return;
    }

    setUser(data.user);
    setIsLoggedIn(true);
    setStage("password");
    setOtp("");
  };

  if (isLoggedIn && user) {
    return <AdminDashboard user={user} />;
  }

  return (
    <div className="login-container">
      {stage === "password" ? (
        <form className="login-form" onSubmit={handleSubmitPassword}>
          <h2>Login</h2>

          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value.toLowerCase())}
            required
            autoComplete="username"
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />

          <button type="submit">Login</button>

          {error && <p className="error">{error}</p>}
          {info && <p className="info">{info}</p>}
        </form>
      ) : (
        <form className="login-form" onSubmit={handleSubmitOtp}>
          <h2>Enter Code</h2>
          <p className="code-text">
            We sent a 6-digit code to {maskedEmail || "your email"}.
          </p>

          <input
            type="text"
            placeholder="6-digit code"
            value={otp}
            onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
            inputMode="numeric"
            required
          />

          <button type="submit" className="btn primary">Verify</button>

          <button
            type="button"
            className="btn outline"
            onClick={() => {
              setStage("password");
              setOtp("");
              setInfo("");
              setError("");
            }}
            style={{ marginTop: 10 }}
          >
            Back
          </button>

          {error && <p className="error">{error}</p>}
          {info && <p className="info">{info}</p>}
        </form>
      )}
    </div>
  );
}

export default Login;
